import React from 'react';
import { Headphones, Ticket, Search } from 'lucide-react';
import V4CeoDeptTemplate from './V4CeoDeptTemplate';
import { SUPPORT_DEPT_DATA, SUPPORT_DEPT_CHAT_RESPONSES } from '../../data/supportDeptData';
import { SUPPORT_DEEP_DIVE, SUPPORT_ALERT_DEEP_DIVES, SUPPORT_DECISION_DEEP_DIVES, SUPPORT_ROW_DEEP_DIVES } from '../../data/supportDeepDiveData';

const TicketRow = ({ item, idx, isDark, onDeepDive }) => {
  const tp = isDark ? 'text-white' : 'text-slate-800';
  const ts = isDark ? 'text-white/50' : 'text-slate-500';
  const border = isDark ? 'border-white/[0.06]' : 'border-black/[0.06]';
  const prioColor = { P1: isDark ? 'text-red-400 bg-red-400/10' : 'text-red-600 bg-red-600/10', P2: isDark ? 'text-amber-400 bg-amber-400/10' : 'text-amber-600 bg-amber-600/10', P3: isDark ? 'text-slate-500 bg-slate-400/10' : 'text-slate-600 bg-slate-600/10' };
  const slaColor = item.sla === 'Breached' ? (isDark ? 'text-red-400' : 'text-red-500') : item.sla === 'At risk' ? (isDark ? 'text-amber-400' : 'text-amber-600') : ts;
  const isP1 = item.priority === 'P1';

  return (
    <div className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border ${isP1 ? (isDark ? 'border-red-500/15 bg-red-950/10' : 'border-red-200/50 bg-red-50/30') : `${border} ${isDark ? 'bg-[#0d1b2a]' : 'bg-[#f0ece4]'}`}`} data-testid={`ticket-${item.id}`}>
      <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded-full ${prioColor[item.priority]}`}>{item.priority}</span>
      <div className="flex-1 min-w-0">
        <p className={`text-[11px] font-semibold truncate ${tp}`}>{item.title}</p>
        <p className={`text-[9px] mt-0.5 ${ts}`}>{item.account} · {item.arr} ARR · {item.owner}</p>
      </div>
      <button
        onClick={() => onDeepDive && onDeepDive(item)}
        className={`flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-medium transition-colors ${isDark ? 'bg-indigo-500/10 text-indigo-400 hover:bg-indigo-500/20' : 'bg-indigo-500/10 text-indigo-600 hover:bg-indigo-500/15'}`}
        data-testid={`ticket-deep-dive-${item.id}`}
      >
        <Search className="w-2.5 h-2.5" /> Deep Dive
      </button>
      <span className={`text-[9px] font-medium flex-shrink-0 ${slaColor}`}>{item.sla}</span>
    </div>
  );
};

const V4SupportDept = ({ isDark, onWorkflowToggle, workflowPanelOpen }) => (
  <V4CeoDeptTemplate
    isDark={isDark} onWorkflowToggle={onWorkflowToggle} workflowPanelOpen={workflowPanelOpen}
    data={SUPPORT_DEPT_DATA} chatResponses={SUPPORT_DEPT_CHAT_RESPONSES}
    deptIcon={Headphones} deptLabel="Support" deptColor={isDark ? 'text-cyan-400' : 'text-cyan-600'}
    agentId="zira" agentName="Zira" escalateLabel="Escalate to Maya" escalateTarget="Maya Singh"
    col2Icon={Ticket} col2Label="Active Tickets" col2Items={SUPPORT_DEPT_DATA.tickets}
    col2Renderer={(item, i, dark, onDeepDive) => <TicketRow key={item.id} item={item} idx={i} isDark={dark} onDeepDive={onDeepDive} />}
    testIdPrefix="support-dept"
    deepDiveScript={SUPPORT_DEEP_DIVE}
    alertDeepDives={SUPPORT_ALERT_DEEP_DIVES}
    decisionDeepDives={SUPPORT_DECISION_DEEP_DIVES}
    rowDeepDives={SUPPORT_ROW_DEEP_DIVES}
    rowKeySelector={(item) => item.id}
  />
);

export default V4SupportDept;
